import { GLOBAL_CONFIG } from "@silo/config";
import { Address, ProtocolKey } from "@silo/types";

export function getIsRevenueMarket(
  protocolKey: ProtocolKey,
  marketAddress: Address
): boolean {
  return (
    protocolKey === GLOBAL_CONFIG.revenue.protocolKey &&
    marketAddress === GLOBAL_CONFIG.revenue.marketAddress
  );
}
